import React, { useEffect } from 'react';
import './TermsOfUse.css';

const TermsOfUse = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="policy-container">
      <div className="policy-hero terms-hero">
        <div className="policy-overlay">
          <h1>Terms of Use</h1>
          <p>Guidelines for using our platform</p>
        </div>
      </div>

      <div className="policy-content">
        <div className="policy-header">
          <div className="policy-meta">
            <div className="meta-item">
              <span className="meta-label">Effective Date:</span>
              <span className="meta-value">20-06-2025</span>
            </div>
            <div className="meta-item">
              <span className="meta-label">Last Updated:</span>
              <span className="meta-value">20-06-2025</span>
            </div>
          </div>
          <div className="company-unit">
            <p>A unit of NexSpyder Technologies Pvt. Ltd.</p>
          </div>
        </div>

        <div className="policy-introduction">
          <p>
            Welcome to www.procartindia.in. This website is operated by Procart India, a unit of NexSpyder
            Technologies Pvt. Ltd. By accessing or using our website, services, or products, you agree to
            follow the terms and conditions outlined in this document. These terms form a legally
            binding agreement between you and Procart India. If you do not agree, please discontinue
            the use of our website or services immediately.
          </p>
        </div>

        <div className="terms-grid">
          <div className="terms-card">
            <div className="terms-icon usage-icon">
              <i className="fas fa-user-check"></i>
            </div>
            <h3>Responsible Usage</h3>
            <p>
              This website is intended for lawful use only. Users agree to use the site responsibly and not
              to engage in any activities that could harm, damage, or interfere with the website, other
              users, or Procart India. This includes, but is not limited to, uploading harmful content,
              attempting to breach security systems, sending unsolicited messages, impersonating others,
              or violating any applicable laws.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon account-icon">
              <i className="fas fa-user-circle"></i>
            </div>
            <h3>Account Responsibility</h3>
            <p>
              If you choose to create an account with us, you are responsible for maintaining the
              confidentiality of your login information and any activity under your account. You agree to
              provide accurate, complete, and up-to-date information during registration and at all times
              thereafter. If we detect fraudulent behavior, misuse, or false information, we reserve the
              right to suspend or terminate the account.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon orders-icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
            <h3>Orders & Payments</h3>
            <p>
              Orders placed on our website are subject to product availability and acceptance by our
              team. We reserve the right to cancel or refuse any order without prior notice. All prices are
              listed in Indian Rupees and are subject to change without prior notice. Payment must be
              made using the available payment methods on our platform. Orders are only processed
              upon successful payment confirmation.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon accuracy-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h3>Content Accuracy</h3>
            <p>
              We make every effort to provide accurate product descriptions, specifications, and images.
              However, errors may occur, and we do not guarantee that all content is complete, reliable, or
              current. We reserve the right to correct any errors, inaccuracies, or omissions and to change
              or update information at any time.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon shipping-icon">
              <i className="fas fa-truck"></i>
            </div>
            <h3>Shipping & Returns</h3>
            <p>
              For details about delivery timelines, warranty, returns, replacements, and cancellations,
              please refer to our Shipping, Refund & Replacement Policy. By placing an order, you
              acknowledge and agree to these terms.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon intellectual-icon">
              <i className="fas fa-copyright"></i>
            </div>
            <h3>Intellectual Property</h3>
            <p>
              All content on this site including text, images, logos, code, videos, and documents are the
              intellectual property of Procart India or its licensors. Unauthorized reproduction,
              modification, distribution, or commercial use of any content is strictly prohibited without
              prior written consent.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon user-content-icon">
              <i className="fas fa-comment-alt"></i>
            </div>
            <h3>User Content</h3>
            <p>
              When submitting reviews, feedback, or project-related content to us, you agree that we may
              use, reproduce, and share that content for marketing, service improvement, or
              communication purposes. You also confirm that such content does not infringe upon the
              rights of any third party and is not unlawful, offensive, or misleading.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon liability-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Limitation of Liability</h3>
            <p>
              While we strive to ensure our website and services are secure and reliable, we cannot
              guarantee uninterrupted access or that the website will be free from viruses or other
              harmful components. Procart India is not liable for any direct, indirect, incidental, or
              consequential loss or damage resulting from the use or inability to use our platform or
              services. This includes delays in delivery, improper installation of products, or damages
              resulting from misuse or modification of electronic components.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon thirdparty-icon">
              <i className="fas fa-external-link-alt"></i>
            </div>
            <h3>Third-party Links</h3>
            <p>
              We may provide links to third-party websites for your convenience. These links do not imply
              endorsement, and we are not responsible for the content, accuracy, or reliability of those
              external websites.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon modifications-icon">
              <i className="fas fa-edit"></i>
            </div>
            <h3>Modifications</h3>
            <p>
              We reserve the right to modify or terminate the services and access to our website at any
              time without notice. We may also update these Terms of Use occasionally. Any changes will
              be posted on this page. Continued use of the website after changes are made indicates your
              acceptance of the updated terms.
            </p>
          </div>

          <div className="terms-card">
            <div className="terms-icon jurisdiction-icon">
              <i className="fas fa-gavel"></i>
            </div>
            <h3>Governing Law</h3>
            <p>
              This agreement is governed by the laws of India. Any legal disputes or proceedings will be
              subject to the jurisdiction of courts located in the city of Bangalore, India.
            </p>
          </div>
        </div>

        <div className="contact-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions or concerns regarding these terms or any part of our services, you
            can contact us using the information below.
          </p>
          <div className="contact-details">
            <div className="contact-item">
              <span className="contact-label">Procart India</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">A unit of NexSpyder Technologies Pvt. Ltd.</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">Email:</span>
              <span className="contact-value">support@procartindia.com</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">Website:</span>
              <span className="contact-value">www.procartindia.in</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;